/**
 * Firebase web config — chỉ lấy từ ENV (`VITE_FIREBASE_*`).
 * Cùng project `my-e-office` với BE QNP (`fcm/my-e-office-firebase-adminsdk.json`).
 */
export const FIREBASE_CONFIG = {
  apiKey: String(import.meta.env.VITE_FIREBASE_API_KEY ?? '').trim(),
  authDomain: String(import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '').trim(),
  projectId: String(import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '').trim(),
  storageBucket: String(
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? ''
  ).trim(),
  messagingSenderId: String(
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? ''
  ).trim(),
  appId: String(import.meta.env.VITE_FIREBASE_APP_ID ?? '').trim(),
};

export const FIREBASE_VAPID_KEY = String(
  import.meta.env.VITE_FIREBASE_VAPID_KEY ?? ''
).trim();

export const isFirebaseConfigured = (): boolean =>
  Boolean(FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.projectId);

/**
 * BE QNP: upsert FCM token (NotificationController.savePushSubscription).
 */
export const FCM_TOKENS_ENDPOINT = '/me/push-subscriptions';
